import { CardBody } from "./CardBody";

export { CardBody };
